import styled from 'styled-components';
import classNames from 'classnames';

type ButtonScheme =
  | 'blue'
  | 'white'
  | 'gray'
  | 'dark'
  | 'darker'
  | 'darkest'
  | 'orange'
  | 'green';
type ButtonSize = 'sm' | 'md' | 'lg' | 'xl';

interface Props {
  scheme?: ButtonScheme;
  size?: ButtonSize;
}

const schemeClass = ({
  disabled,
  scheme,
}: {
  disabled?: boolean;
  scheme?: ButtonScheme;
}) => {
  if (disabled) {
    if (scheme === 'blue') {
      return 'text-white bg-black-gray';
    }
    if (scheme === 'white') {
      return 'text-black-gray bg-white';
    }
    if (scheme === 'gray') {
      return 'text-black-gray bg-black-black bg-opacity-50';
    }
    if (scheme === 'dark') {
      return 'text-black-gray bg-black-#2d';
    }
    if (scheme === 'darker') {
      return 'text-black-gray bg-black-#2d';
    }
    if (scheme === 'darkest') {
      return 'text-black-gray bg-black';
    }
    if (scheme === 'orange') {
      return 'text-white bg-black-gray';
    }
    if (scheme === 'green') {
      return 'text-white bg-black-gray';
    }
  }
  if (scheme === 'blue') {
    return 'text-white bg-blue hover:bg-blue-active';
  }
  if (scheme === 'white') {
    return 'text-black bg-white hover:bg-white-light';
  }
  if (scheme === 'gray') {
    return 'text-white  bg-black-black bg-opacity-50 hover:bg-blue hover:bg-opacity-100';
  }
  if (scheme === 'dark') {
    return 'text-white bg-black-#34 hover:bg-black-#45';
  }
  if (scheme === 'darker') {
    return 'text-white bg-black-#28 hover:bg-black-#34';
  }
  if (scheme === 'darkest') {
    return 'text-black-gray bg-black hover:text-white';
  }
  if (scheme === 'orange') {
    return 'text-white bg-orange hover:bg-orange-active';
  }
  if (scheme === 'green') {
    return 'text-white bg-green hover:bg-green-active';
  }
};

const Button = styled.button.attrs<Props>(
  ({ scheme = 'blue', size = 'md', disabled }) => {
    const baseCx =
      'flex items-center justify-center rounded outline-none focus:outline-none px-10';
    const schemeCx = schemeClass({ disabled, scheme });
    const className = classNames(baseCx, schemeCx, {
      'h-25': size === 'sm',
      'h-30': size === 'md',
      'h-35': size === 'lg',
      'h-40': size === 'xl',
      'text-sm': size === 'sm',
      'text-base': size !== 'sm',
      'cursor-default': disabled,
    });
    return { className };
  }
)<Props>``;

export default Button;
